import HTTP_METHODS from "src/general/constants/http/httpMethods";
import {
	UserPostRequest as Req,
	UserPostResponse as Res,
} from "src/business.InterfaceLayer/store/entities/user.entity/redux/api/types/POST";
import { createBaseQueryDefinition } from "src/business.InterfaceLayer/store/services/utils.service/ResponseTransforms";
import MAIN_PATHS from "src/business.InterfaceLayer/store/mainPaths";
import { ApiQueryBuilder } from "src/business.InterfaceLayer/store/types/ApiQueryBuilder.type";
import { AuthFromDtoPost as Dto } from "src/business.InterfaceLayer/store/entities/user.entity/services/dto/from.dto";
import { Nullable } from "../../../../../types/Nullable.type";
import USER_PATHS from "../../paths";
import { USER_FIELDS } from "../../fields";

const postRequestBaseDefinition = createBaseQueryDefinition(
	HTTP_METHODS.POST,
	MAIN_PATHS.CORE
);

const userApiPostQueries = (build: ApiQueryBuilder) => ({
	postUserCreate: build.mutation<Nullable<Res.UserCreate>, Req.UserCreate>({
		query: (body) => ({
			...postRequestBaseDefinition({ path: USER_PATHS.USERS }),
			body,
		}),
		transformResponse: Dto.userCreateFromDto,
		invalidatesTags: [`${MAIN_PATHS.USER}TAG`],
	}),
	postUserStatusUpdate: build.mutation<
		Nullable<Res.UserStatusUpdate>,
		Req.UserStatusUpdate
	>({
		query: (body) => ({
			...postRequestBaseDefinition({
				path: `${USER_PATHS.USER_UPDATE_STATUS}/status`,
			}),
			body,
		}),
		transformResponse: Dto.userStatusUpdateFromDto,
		invalidatesTags: [`${MAIN_PATHS.USER}TAG_COUNT`, `${MAIN_PATHS.USER}TAG`],
	}),
});

export default userApiPostQueries;
